module.exports = __webpack_public_path__ + "static/media/electricity.ee102adb.svg";